import { Helmet } from 'react-helmet-async'
import { useEffect } from 'react'

export default function Soporte() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Helmet>
        <title>Soporte - Oriental Ramirez</title>
        <meta name="description" content="Soporte técnico para motocicletas y vehículos Oriental Ramirez" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Soporte
            </h1>

            <div className="prose prose-lg max-w-none">
              <p className="text-gray-600 mb-6">
                Nuestro equipo de soporte técnico está disponible para asesorarte en mantenimiento, reparaciones y cualquier consulta sobre tu motocicleta o vehículo.
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  Soporte técnico
                </h2>
                <p className="text-gray-700 mb-4">
                  Visita nuestras sucursales o contáctanos para más información.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
